import styles from './AboutUsDummy.module.css';
import iPhone from '../../assets/images/iphone.svg';
import { detectNextLine, iosCaller, urlify } from '../../Utilities';

const AboutUsDummy = ({ disableVision, aboutUs, tagline }) => {
  return (
    <section>
      {/* Top Split Section */}
      {!disableVision && (
        <div className={styles.splitSection}>
          <div className={styles.left}>
            <p className={styles.subHeading}>{tagline}</p>
            <h2 className={`${styles.mainHeading}`}>
              Our <span className={styles.highlight}>Message</span>
            </h2>
            <p
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: urlify(detectNextLine(aboutUs)) }}
            />
          </div>

          {/* <div className={`position-relative ${styles.right}`}>
            <img
              src={iPhone}
              loading='lazy'
              alt='Mobile App Mockup'
              className={`position-relative ${styles.image}`}
            />
            <img
              src={iPhone}
              loading='lazy'
              alt='Mobile App Mockup'
              className={`position-absolute ${styles.rotationAnimation} ${styles.image} ${styles.imageAbsolute}`}
            />
          </div> */}
        </div>
      )}
    </section>
  );
};

export default AboutUsDummy;
